import React, { useState } from 'react';
import Add from '@mui/icons-material/Add';
import { AppButton } from '../../../../components/UI';
import { Link, useParams, withRouter } from 'react-router-dom';
import { getContsoci } from '../../../../services/ContactService';
import Edit from '@mui/icons-material/Edit';
import LinkedIn from '@mui/icons-material/LinkedIn';
import { Box, Button, Chip, IconButton, Tooltip, Typography } from '@mui/material';
import { commonGridSx, gridLocaleText, makeGridToolbar } from '../../../../utils/gridStyles';
import { DataGrid } from '../../../../components/SortableDataGrid/SortableDataGrid';

const CustomToolbar = makeGridToolbar('Contacts');

const CONTACT = ({ history, nomSociete }) => {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 50 });
  const [rowCount, setRowCount] = useState(0);

  React.useEffect(() => {
    let isActive = true;
    (async () => {
      setLoading(true);
      try {
        const res = await getContsoci(id, paginationModel.page + 1);
        if (!isActive) return;
        setContacts(res.data.contactsOfSociete || []);
        setRowCount(res.data.count || 0);
      } catch {
      } finally {
        if (isActive) setLoading(false);
      }
    })();
    return () => { isActive = false; };
  }, [id, paginationModel.page]);

  const columns = [
    {
      field: 'titre', headerName: 'TITRE', flex: 80, minWidth: 80,
      renderCell: (p) => <Typography sx={{ fontSize: '1rem', color: '#475569' }}>{p.value || '—'}</Typography>,
    },
    {
      field: 'prenom', headerName: 'PRÉNOM', flex: 140, minWidth: 140,
      renderCell: (p) => (
        <Link to={{ pathname: `/societe/${id}/contacts/${p.row.uuid}/view` }}
          style={{ textDecoration: 'none', color: '#0ea5e9', fontSize: '1rem', textTransform: 'capitalize' }}>
          {p.value ? p.value.charAt(0).toUpperCase() + p.value.slice(1) : '—'}
        </Link>
      ),
    },
    {
      field: 'nom', headerName: 'NOM', flex: 130, minWidth: 130,
      renderCell: (p) => (
        <Link to={{ pathname: `/societe/${id}/contacts/${p.row.uuid}/view` }}
          style={{ textDecoration: 'none', fontWeight: 600, color: '#0f172a', fontSize: '1rem', textTransform: 'uppercase' }}>
          {p.value || '—'}
        </Link>
      ),
    },
    {
      field: 'fonction', headerName: 'FONCTION', flex: 170, minWidth: 170,
      renderCell: (p) => (
        <Typography sx={{ fontSize: '1rem', color: '#475569', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {p.value || '—'}
        </Typography>
      ),
    },
    {
      field: 'localisation', headerName: 'LOCALISATION', flex: 130, minWidth: 130,
      renderCell: (p) => <Typography sx={{ fontSize: '1rem', color: '#475569' }}>{p.value || '—'}</Typography>,
    },
    {
      field: 'telFix', headerName: 'TÉL DIRECT', flex: 130, minWidth: 130,
      renderCell: (p) => <Typography sx={{ fontSize: '1rem', color: '#334155' }}>{p.value || '—'}</Typography>,
    },
    {
      field: 'mobile', headerName: 'MOBILE', flex: 130, minWidth: 130,
      renderCell: (p) => <Typography sx={{ fontSize: '1rem', color: '#334155' }}>{p.value || '—'}</Typography>,
    },
    {
      field: 'email', headerName: 'EMAIL', flex: 210, minWidth: 210,
      renderCell: (p) => (
        <Typography sx={{ fontSize: '1rem', color: '#334155', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {p.value || '—'}
        </Typography>
      ),
    },
    {
      field: 'linkedIn', headerName: 'LKD', flex: 60, minWidth: 60, align: 'center', headerAlign: 'center', sortable: false,
      renderCell: (p) => p.value ? (
        <Tooltip title="Voir LinkedIn">
          <a href={p.value} target="_blank" rel="noreferrer" style={{ color: '#0a66c2', lineHeight: 0 }}>
            <LinkedIn sx={{ fontSize: 20 }} />
          </a>
        </Tooltip>
      ) : <Typography sx={{ color: '#cbd5e1', fontSize: '1rem' }}>—</Typography>,
    },
    {
      field: 'actions_col', headerName: 'ACTIONS', width: 130, sortable: false, filterable: false,
      renderCell: (p) => (
        <Tooltip title="Modifier">
          <IconButton size="small"
            onClick={() => history.push(`/societe/${id}/contacts/${p.row.uuid}/edit`, { nomSociete })}
            sx={{ color: '#eab308', background: '#fefce8', borderRadius: '8px', '&:hover': { background: '#fef9c3' }, p: 0.75 }}>
            <Edit sx={{ fontSize: 16 }} />
          </IconButton>
        </Tooltip>
      ),
    },
  ];

  const rows = (contacts || []).map((c) => ({ ...c, id: c.uuid }));

  return (
    <Box>
      <AppButton variant="primary" size="small" startIcon={<Add fontSize="small" />} sx={{ mb: 1.5 }}
        onClick={() => history.push(`/societe/${id}/contacts/add`, { nomSociete })}>
        Ajouter un contact
      </AppButton>
      <Box sx={{ borderRadius: 3, border: '1px solid #e2e8f0', height: '47vh', minHeight: 300, background: '#fff', overflow: 'hidden', display: 'flex', flexDirection: 'column', boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.04)' }}>
        <DataGrid
          rows={rows}
          columns={columns}
          getRowId={(row) => row.uuid}
          loading={loading}
          paginationMode="server"
          rowCount={rowCount}
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          pageSizeOptions={[50, 100]}
          disableRowSelectionOnClick
          showToolbar
          slots={{ toolbar: CustomToolbar }}
          slotProps={{ loadingOverlay: { variant: 'skeleton', noRowsVariant: 'skeleton' } }}
          localeText={gridLocaleText}
          sx={commonGridSx}
        />
      </Box>
    </Box>
  );
};

export default withRouter(CONTACT);

